// @flow
import { type JSSThemeDefaultPromotionsType } from '../JSSThemeDefaultPromotions';

export const JSSThemePromotions61200: JSSThemeDefaultPromotionsType = (
  themeVars
) => {
  const { margins } = themeVars;
  return {
    SeasonalPromotion: {
      promoHeading: {
        padding: 0,
        position: 'relative',
      },
      buttonRoot: {
        background: 'transparent',
        position: 'absolute',
        top: 70,
      },
      img: {
        objectPosition: 'right',
      },
      root: {
        padding: ['18px', margins.md],
      },
    },
    PromotionsComponent: {
      listTabs: {
        '@media screen and (max-width: 400px)': {
          fontSize: '16px',
        },
        '@media screen and (max-width: 330px)': {
          fontSize: '14px',
        },
      },
    },
  };
};
